import { Button, Form, message } from "antd";
import { FC, useState } from "react";
import PhoneInputWithCountrySelect, {
  isValidPhoneNumber,
  parsePhoneNumber,
} from "react-phone-number-input";
import OTPStep from "./OTPStep";
import { useMutation } from "@tanstack/react-query";
import { useIntl } from "react-intl";

interface LoginWithOTPProps {
  login: (...rest: any[]) => any;
  verifyOTP: (data: any) => void;
  sendOTP: (data: any) => void;

  onLoginSuccess?: (res: any) => void;
  onLoginError?: (err: any) => void;
}

const LoginWithOTP: FC<LoginWithOTPProps> = ({
  sendOTP,
  verifyOTP,
  login,
  onLoginError,
  onLoginSuccess,
}) => {
  const intl = useIntl();
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  const [phoneDetails, setPhoneDetails] = useState({
    phone: "",
    phone_country_code: "",
  });

  const { mutate, isLoading } = useMutation(login, {
    onSuccess: (res: any) => {
      if (res?.code !== "ERR_BAD_REQUEST" && res?.code !== "ERR_BAD_RESPONSE") {
        message.success(
          intl.formatMessage({ id: "OTPSENT" }) || "تم إرسال كود التحقق"
        );
        setStep(2);
      } else {
        message.error(
          res?.response?.data?.message || res?.response?.data[0] || "حدث خطأ"
        );
      }
    },
    onError: (err: any) => {
      err?.response?.data[0] ||
        message.error(err?.response?.data?.message || "حدث خطأ");
    },
  });
  const submitMobileNumber = () => {
    const phoneNumber = parsePhoneNumber(phone);
    if (!phoneNumber || !phoneNumber?.country) {
      message.error(
        intl.formatMessage({ id: "invalidPhoneNumber" }) ||
          "رقم الجوال غير صالح"
      );
      return;
    } else {
      setPhoneDetails({
        phone: phoneNumber?.nationalNumber,
        phone_country_code: phoneNumber?.country,
      });
    }
    const countryCode = phoneNumber?.country;
    mutate({
      phone: phoneNumber?.nationalNumber,
      phone_country_code: countryCode,
    });
  };
  return (
    <div className=" p-6 space-y-4 rounded-lg ">
      {step === 1 ? (
        <Form layout="vertical" onFinish={() => {}} className="space-y-4">
          <Form.Item
            name="phone"
            label={intl.formatMessage({ id: "phone" })}
            required={false}
            rules={[
              {
                required: true,
                message: intl.formatMessage({ id: "phoneNumberRequired" }),
              },
              {
                validator: (rule, value) => {
                  if (isValidPhoneNumber(value)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    intl.formatMessage({ id: "invalidPhoneNumber" })
                  );
                },
              },
            ]}
            className="w-full "
            hasFeedback
          >
            <PhoneInputWithCountrySelect
              defaultCountry="SA"
              className="w-full"
              onChange={(value) => {
                if (value) {
                  setPhone(value);
                } else {
                  setPhone("");
                }
              }}
              name="phone_country_code"
              international
              hasFeedback
              limitMaxLength={true}
            />
          </Form.Item>
        </Form>
      ) : null}

      {step === 2 ? (
        <OTPStep
          verifyOTP={verifyOTP}
          reSendOtp={() =>
            sendOTP({
              phone: phoneDetails?.phone,
              phone_country_code: phoneDetails?.phone_country_code,
            })
          }
          countryCode={phoneDetails?.phone_country_code}
          phone={phone}
          onLoginSuccess={onLoginSuccess}
          onLoginError={onLoginError}
        />
      ) : (
        <div className="my-2 py-2">
          <Button
            block
            type="primary"
            onClick={submitMobileNumber}
            loading={isLoading}
          >
            {intl.formatMessage({ id: "submit" })}
          </Button>
        </div>
      )}
    </div>
  );
};

export default LoginWithOTP;
